<script>
    export default {
        name: "HeightMixin",
        data () {
            return {
                heightValueToClass : {
                    small: 'learnworlds-size-small',
                    normal: 'learnworlds-size-normal',
                    large: 'learnworlds-size-large',
                    extraLarge: 'learnworlds-size-extra-large'
                }
            }
        },
        mounted () {
            this.$nextTick( () => {

                if (this.myData) {
                    // Adding watcher on myData after myData is created.
                    // If watcher is set on instantiation, it asks for myData before handleRegistration finishes.
                    // At that point sectionId is not set yet, so sectionData returns an empty object.
                    this.$watch('myData.responsiveHeightClass', function (oldData, newData) {
                        if (typeof oldData === 'undefined' && typeof newData === 'undefined') {
                            return;
                        }

                        const responsiveHeightClass = newData;
                        if (responsiveHeightClass && responsiveHeightClass[this.activeDevicePreview]) {
                            this.updateHeightClass(responsiveHeightClass[this.activeDevicePreview]);
                        }
                    }, {deep: true});
                }
                // push responsive functions to nodeState
                this.responsiveFunctions.push('updateHeightClassForDevice');
            })
        },
        computed: {
            allOptionHeightClasses () {
                let classes = [];

                for (let key in this.heightOptions) {
                    if (!this.heightOptions.hasOwnProperty(key)) {
                        continue;
                    }

                    classes.push(this.heightOptions[key].styleClass);
                }

                return classes;
            },
            heightOptions () {
                return {
                    small : {
                        icon : this.imagePath + "/author/images/pagesbuilder/height-small.png",
                        label : "Small",
                        styleClass : "learnworlds-size-small"
                    },
                    normal : {
                        icon : this.imagePath + "/author/images/pagesbuilder/height-normal.png",
                        label : "Normal",
                        styleClass : "learnworlds-size-normal"
                    },
                    large : {
                        icon : this.imagePath + "/author/images/pagesbuilder/height-large.png",
                        label : "Large",
                        styleClass : "learnworlds-size-large"
                    },
                    extraLarge : {
                        icon : this.imagePath + "/author/images/pagesbuilder/height-extra-large.png",
                        label : "Extra large",
                        styleClass : "learnworlds-size-extra-large"
                    },
                }
            },
            currentHeightClass () {
                return this.heightValueToClass[this.getHeight()];
            }
        },
        methods: {
            getHeight () {
                return this.getKeyForMatchingClass(this.heightValueToClass , {defaultValue :"normal"});
            },
            getHeightOptions(){
                return this.heightOptions;
            },
            getHeightOptionClass(optionKey, selectedClass){
                let classObj = {};

                let optionStyleClass = this.heightOptions[optionKey].styleClass;

                if (this.myNode.classList && this.myNode.classList.contains(optionStyleClass)) {
                    classObj[selectedClass] = true;
                }

                return classObj;
            },
            setHeightClass(optionKey){
                let responsiveHeightClass = this.myData.responsiveHeightClass || {};

                if (!responsiveHeightClass['desktop']) {
                    responsiveHeightClass['desktop'] = this.currentHeightClass;
                }
                responsiveHeightClass[this.activeDevicePreview] = this.heightOptions[optionKey].styleClass;
                this.changeMyData({responsiveHeightClass});
            },
            updateHeightClassForDevice (device, node) {
                const responsiveHeightClass = this.myData.responsiveHeightClass || {};

                if (responsiveHeightClass) {
                    let newClass = false;
                    if (responsiveHeightClass[device]) {
                        newClass = responsiveHeightClass[device];
                    } else if (responsiveHeightClass['desktop']) {
                        newClass = responsiveHeightClass['desktop'];
                    }
                    if (newClass) {
                        this.updateHeightClass(newClass, node);
                    }
                }
            },
            updateHeightClass (newClass, node) {
                let params = {
                    newClass : newClass,
                    classesToRemove : this.allOptionHeightClasses,
                    update : true
                }

                this.applyClass(params, node);

                //event is used by other sideform components to readjust values (i.e padding component)
                window.eventBus.$emit("resetPaddingProps"); // TODO: this breaks when we change active device
                window.eventBus.$emit("recompute-layout");
            },
        },
        watch: {
            activeDevicePreview: {
                handler () {
                    this.updateHeightClassForDevice(this.activeDevicePreview)
                }
            }
        },
    }
</script>
